import { useEffect, useState } from "react";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import StatsStrip from "@/components/sections/StatsStrip";
import About from "@/components/sections/About";
import Credentials from "@/components/sections/Credentials";
import Programs from "@/components/sections/Programs";
import Coaches from "@/components/sections/Coaches";
import Gallery from "@/components/sections/Gallery";
import Testimonials from "@/components/sections/Testimonials";
import Registration from "@/components/sections/Registration";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function LandingPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Reveal-on-scroll for elements with .fade-up
  useEffect(() => {
    const els = document.querySelectorAll(".fade-up");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen bg-[#0a0a0a] text-white"
    >
      <Navbar scrolled={scrolled} />
      <Hero />
      <StatsStrip />
      <About />
      <Credentials />
      <Programs />
      <Coaches />
      <Gallery />
      <Testimonials />
      <Registration />
      <Contact />
      <Footer />
    </main>
  );
}
